<template>
  <a-modal
    v-model:visible="visible"
    :title="title"
    :after-close="afterClose"
    :width="currStep == 'edit' ? 420 : currStep == 'preview' ? 1200 : 970"
    :z-index="1001"
    :closable="submitting ? false : true"
    :mask-closable="submitting ? false : true"
    :keyboard="submitting ? false : true"
    :body-style="{
      minHeight: '300px',
      maxHeight: currStep == 'preview' ? '1000px' : '700px',
      overflow: 'auto'
    }"
  >
    <div
      v-if="currStep == 'none'"
      class="w-full flex justify-center h-[300px] items-center"
    >
      <a-spin tip="处理中..." size="middle" />
    </div>
    <!-- 表盘校验 -->
    <div v-show="currStep == 'valid'">
      <!-- 资源校验失败 -->
      <template v-if="invalidLayers.length">
        <a-alert message="图层资源有误，无法导出，请调整！" type="error" />
        <WatchfaceThemesValid
          :invalid-res="invalidLayers"
          @close="onValidFaild"
        />
      </template>

      <!-- 内存大小校验失败 -->
      <template v-else-if="isOverRam">
        <a-alert
          message="图片资源占用固件内存超标，无法导出，请调整！"
          type="error"
        />
        <WatchfaceRamTable @close="onValidFaild" />
      </template>

      <!-- 非黑校验 -->
      <template v-else-if="aodValidRes?.valid === false">
        <a-alert message="息屏校验失败，请调整！" type="error" />
        <WatchfaceAODValid
          :data="aodValidRes.details ?? []"
          @close="onValidFaild"
        />
      </template>
    </div>

    <!-- 表盘功耗 -->
    <div v-show="currStep == 'power'">
      <power-class-details
        :watchface-power-data="watchfacePowerData"
        @close="() => (visible = false)"
      />
    </div>

    <!-- 表盘预览图 -->
    <div v-show="currStep == 'preview'">
      <div class="ml-2 mb-3 text-[#E66138]">
        注意：请检查图中数据源是否为默认值，如有问题请点击刷新或自行上传。
      </div>

      <!-- 静态预览图 -->
      <div class="pl-2 mb-2 opacity-70">静态预览图</div>
      <WatchfacePreviewStatic ref="previewRef" />

      <!-- 动态预览图 -->
      <div class="pl-2 mb-2 opacity-70">动态预览图</div>
      <div class="mt-2.5">
        <WatchfacePreviewAnimation
          ref="animaionRef"
          :watchface-path="watchfacePath"
        />
      </div>
    </div>

    <!-- 编辑表盘信息 -->
    <div v-show="currStep == 'edit'" class="flex justify-center">
      <div class="w-[320px]">
        <form-watchface-manage
          ref="manageRef"
          :disabled-keys="
            submitting
              ? [
                  'name',
                  'deviceType',
                  'shape',
                  'version',
                  'author',
                  'pkgName',
                  'dir',
                  'watchOS',
                  'merchantId',
                  'copyright',
                  'designType',
                  'highlight',
                  'rule',
                  'dataSourceList',
                  'jumpAppList',
                  'remark'
                ]
              : ['deviceType', 'shape', 'watchOS']
          "
        />
      </div>
    </div>

    <!-- 按钮 -->
    <template #footer>
      <!-- 导出之前的准备 -->
      <template v-if="!watchfaceExporting">
        <div
          v-if="currStep != 'valid' && currStep != 'none'"
          class="flex justify-end mt-4 w-full px-8"
        >
          <!-- 刷新预览图 -->
          <a-button
            v-if="currStep == 'preview'"
            size="middle"
            class="!w-[150px]"
            :loading="refreshingStatic"
            @click="
              async () => {
                refreshingStatic = true;
                try {
                  await previewRef?.regenerateAll?.();
                } finally {
                  refreshingStatic = false;
                }
              }
            "
            >刷新预览图（静态）</a-button
          >
          <a-button :loading="submitting" @click="() => (visible = false)">
            取消
          </a-button>

          <a-button
            v-if="
              currStep == 'edit' || (currStep == 'preview' && supporPowerClass)
            "
            class="ml-2.5"
            :loading="submitting"
            @click="onPre"
            >上一步
          </a-button>

          <!-- 导出或下一步 -->
          <a-button
            v-if="['power', 'preview'].includes(currStep)"
            type="primary"
            class="ml-2.5"
            :loading="submitting"
            @click="onNext"
            >下一步
          </a-button>

          <a-button
            v-if="currStep == 'edit' && ElectronApi.isNormal()"
            class="ml-2.5"
            type="primary"
            :loading="submitting"
            @click="manageRef?.preview"
          >
            预览
          </a-button>

          <a-button
            v-if="currStep == 'edit'"
            class="ml-2.5"
            type="primary"
            :loading="submitting"
            @click="saveThenExport"
          >
            导出
          </a-button>
        </div>
        <div v-if="currStep == 'valid'" class="flex justify-center mt-4 px-8">
          <a-button @click="() => (visible = false)"> 取消 </a-button>
        </div>
      </template>
      <!-- 导出中 -->
      <template v-if="watchfaceExporting">
        <div class="w-full px-5 mt-4">
          <a-button class="!w-full" :loading="true">导出中... </a-button>
          <div
            v-if="imageProgress.onProgress"
            class="text-center opacity-75 mt-1"
          >
            图片处理中 <span class="w-20">{{ imageProgress.cached }} </span>/{{
              imageProgress.total
            }}
          </div>
        </div>
      </template>
    </template>
    <!-- 表盘导出成功页面 -->
    <ModalExportSuccess ref="exportSuccessRef" />
    <!-- 表盘binw文件太大 -->
    <ModalBinOversize ref="binOversizeRef" />
  </a-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import WatchfacePreviewStatic from './WatchfacePreviewStatic.vue';
import { nextTick } from 'vue';
import {
  WatchfaceFormData,
  useWatchfacePowerClass,
  useWatchfaceManage,
  watchfaceExporting,
  useWatchfaceRam,
  useWatchfaceExport,
  recalculateWatchfaceRaming,
  useWebVersion,
  useImageBufferCache,
  AodThemeValidRse,
  useWatchfaceAodPixel
} from '@/hooks';
import { Modal } from 'ant-design-vue';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { canUse } from '@/utils/can-use.utils';
import { useLayerStore } from '@/store/use-layer-store';
import {
  WatchfaceInvalidItem,
  validWatchfaceThemes
} from '@/utils/watchface-export/validWatchfaceThemes';
import { exportDialTrack } from '@/utils/track/app';
import { GlobalConfig } from '@/services/gloabl.config';
import { Introduce } from '@/types/watchface';
import { ElectronApi } from '@/services/electron.api';

const { editWatchface } = useWatchfaceManage();
const { exportWatchface } = useWatchfaceExport();
const { resetWatchfacePowerData, watchfacePowerData } =
  useWatchfacePowerClass();

const { checkEditorVersion } = useWebVersion();

const { canuseAODValid, validAODPixels } = useWatchfaceAodPixel();

// 当前页面
const currStep = ref<'power' | 'preview' | 'edit' | 'none' | 'valid'>('none');

const exportSuccessRef = ref();
const binOversizeRef = ref();

const watchfacePath = ref('');
const watchfaceStore = useWatchfaceStore();

const emits = defineEmits<{
  (event: 'close', bin?: string): void;
  (event: 'valid-fail'): void;
}>();

const loading = ref(false);
const refreshingStatic = ref(false);
const submitting = computed(() => watchfaceExporting.value || loading.value);
const binFile = ref('');

// 导出进度
const { cachingImageData } = useImageBufferCache();
const imageProgress = computed(() => {
  const cached = cachingImageData.value.cached.size;
  const total = cachingImageData.value.total.size;
  const onProgress = cached < total;
  return {
    onProgress,
    cached,
    total
  };
});

const onPre = () => {
  if (currStep.value == 'edit') {
    currStep.value = 'preview';
  } else if (currStep.value == 'preview' && supporPowerClass.value) {
    currStep.value = 'power';
  }
};
const onNext = async () => {
  if (currStep.value == 'preview') {
    // 验证预览图是否都存在
    const { valid = true, err } = previewRef.value?.valid?.() ?? {};
    if (!valid) {
      Modal.warning({
        title: '预览图有误',
        content: err,
        okText: '知道了',
        zIndex: 1002
      });
      return;
    }
  }
  currStep.value = currStep.value == 'power' ? 'preview' : 'edit';
};

// 保存表盘数据-开始导出表盘
const saveThenExport = async () => {
  try {
    if (watchfaceExporting.value) return;

    loading.value = true;

    const res = await manageRef.value?.getData();
    if (!res?.valid) return;
    const formData = res.data as WatchfaceFormData;
    const formIntroData = res.introData as Introduce;
    if (!watchfacePath.value) return;

    // 先更新数据
    const editRes = res?.changed
      ? await editWatchface(watchfacePath.value, formData, formIntroData)
      : true;
    if (!editRes) return;

    const now = Date.now();
    // 执行导出
    const {
      binPath,
      success: _success = false,
      mwzBlob,
      error,
      overSize
    } = (await exportWatchface()) ?? {};
    if (!_success) throw error;
    if (!binPath) throw error ?? '未获取到binPath';
    exportDialTrack({
      dial_name: formData.name,
      device_model: formData.deviceType as string,
      device_size: formData.size,
      version: formData.version as string,
      export_time: (Date.now() - now) / 1000
    });
    binFile.value = binPath;

    // 校验bin文件是否超过最大值
    const { isOver = false, maxBinLimit = 0, binSize = 0 } = overSize ?? {};
    if (isOver) {
      visible.value = false;
      // 打开导出失败modal
      binOversizeRef.value?.open?.(binSize, maxBinLimit);
      return;
    }

    if (onSuccess.value) {
      visible.value = false;
      onSuccess.value?.(binPath, mwzBlob);
    } else {
      visible.value = false;
      exportSuccessRef.value?.open(binPath, mwzBlob);
    }
  } catch (error) {
    Modal.warning({
      title: '导出失败',
      content: String(error),
      okText: '知道了',
      zIndex: 1001
    });
  } finally {
    loading.value = false;
  }
};

const previewRef = ref();
const animaionRef = ref();

const manageRef = ref();

const visible = ref(false);
const onSuccess = ref<(bin: string, mwzBlob?: Blob) => void>();
const open = async (_path: string, _success?: (bin: string) => void) => {
  if (!checkEditorVersion()) return;

  binFile.value = '';
  watchfacePath.value = _path;
  onSuccess.value = _success;

  // 判断是否支持功耗
  supporPowerClass.value = canUse('power-class').valid;

  await nextTick();
  visible.value = true;

  setTimeout(() => {
    init();
  }, 50);
};
defineExpose({ open });

const init = async () => {
  const _path = watchfacePath.value;
  if (!_path) return;
  // 校验表盘
  await validWatchface();

  // 根据校验结果重置currStep
  currStep.value =
    watchfaceValid.value == false
      ? 'valid'
      : supporPowerClass.value
      ? 'power'
      : 'preview';
  // 静态预览图
  previewRef.value?.initData?.(_path);
  // 动态预览图
  animaionRef.value?.initData();

  manageRef.value?.initData?.(_path);

  if (supporPowerClass.value) {
    await resetWatchfacePowerData();
    watchfaceStore.powerConsumptionLevel = watchfacePowerData.value?.powerClass;
  }
  if (watchfaceExporting.value) {
    currStep.value = 'edit';
  }
};

const afterClose = () => {
  manageRef.value?.clear();
  invalidLayers.value = [];
  watchfaceValid.value = true;
  aodValidRes.value = { valid: true };
  loading.value = false;
  currStep.value = 'none';
  emits('close', binFile.value);
};

// 功耗数据
const supporPowerClass = ref(false);

// 表盘title
const title = computed(() => {
  const _step = currStep.value;
  const _power = supporPowerClass.value;
  if (_step == 'none') return '数据校验';
  if (_step == 'valid') {
    if (invalidLayers.value.length) {
      return '数据校验';
    } else {
      return '数据校验';
    }
  }

  let title1 = '';
  if (_power) {
    title1 =
      _step == 'power'
        ? '第一步（1/3）'
        : _step == 'preview'
        ? '第二步（2/3）'
        : '第三步（3/3）';
  } else {
    title1 = _step == 'preview' ? '第一步（1/2）' : '第二步（2/2）';
  }
  const title2 =
    _step == 'power'
      ? '表盘功耗评级'
      : _step == 'preview'
      ? '检查预览图'
      : '导出表盘';

  return title1 + '：' + title2;
});

// 表盘校验
const layerStore = useLayerStore();
const watchfaceValid = ref(true);
const invalidLayers = ref<WatchfaceInvalidItem[]>([]);
const isOverRam = ref(false);

// 息屏校验
const aodValidRes = ref<
  | {
      valid: boolean;
      details?: AodThemeValidRse[];
    }
  | undefined
>();

const { recalculateThemesRam, themeRamItems, checkIsOverRam } =
  useWatchfaceRam();
const validWatchface = async () => {
  try {
    console.time('[export-perf] 校验总耗时');
    invalidLayers.value = [];
    isOverRam.value = false;
    watchfaceValid.value = false;
    // 表盘资源校验
    console.time('[export-perf] validWatchfaceThemes');
    invalidLayers.value = await validWatchfaceThemes({
      themes: layerStore.themes,
      description: watchfaceStore.description
    });
    console.timeEnd('[export-perf] validWatchfaceThemes');

    if (GlobalConfig.validWatchfaceRam) {
      if (!themeRamItems.value.length || recalculateWatchfaceRaming.value) {
        // 表盘内存校验
        console.time('[export-perf] recalculateThemesRam');
        recalculateThemesRam();
        console.timeEnd('[export-perf] recalculateThemesRam');
      }
      isOverRam.value = checkIsOverRam(themeRamItems.value);
    }

    // 非黑校验
    if (canuseAODValid.value) {
      console.time('[export-perf] validAODPixels');
      aodValidRes.value = await validAODPixels();
      console.timeEnd('[export-perf] validAODPixels');
    }
  } catch (error) {
    invalidLayers.value = [];
    isOverRam.value = false;
    watchfaceValid.value = false;
    aodValidRes.value = undefined;
  } finally {
    console.timeEnd('[export-perf] 校验总耗时');
    watchfaceValid.value =
      invalidLayers.value.length ||
      isOverRam.value ||
      aodValidRes.value?.valid === false
        ? false
        : true;
  }
};
const onValidFaild = () => {
  visible.value = false;
  emits('valid-fail');
};
</script>
<style lang="less"></style>
